module.exports = __webpack_public_path__ + "img/transport04.6db0bdd3.png";